import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { FilterProvider } from './context/FilterContext';
import Navigation from './components/Navigation';
import Dashboard from './pages/Dashboard';
import MediaDetail from './pages/MediaDetail';
import ChannelDeepDive from './pages/ChannelDeepDive';
import './App.css';

function App() {
  return (
    <FilterProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Navigation />
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/media/:mediaId" element={<MediaDetail />} />
            <Route path="/media/:mediaId/channel/:channelId" element={<ChannelDeepDive />} />
          </Routes>
        </div>
      </Router>
    </FilterProvider>
  );
}

export default App;